<div class="callout">
    <div class="text-center callout rounded padding-center medium-grey-bg">
     <div class="large-text color-grey">
       {{message?message:'No Data'}}
       
     </div>
    </div>
</div>